export default {
    // Allows to define a special path for ressources.
    // For exemple if your portal is deployed on a.b.sai-erp.net/portal/ you need to specify /portal/.
    // By default if not set , the value will be /
    // relativePath: '/'
}